module.exports = __webpack_public_path__ + "img/7827b8e.svg";